/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Document_Uploaded_TitleInputs */

const en_notifications_document_uploaded_title = /** @type {(inputs: Notifications_Document_Uploaded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document uploaded on your case`)
};

const pt_br2_notifications_document_uploaded_title = /** @type {(inputs: Notifications_Document_Uploaded_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento enviado no seu caso`)
};

/**
* | output |
* | --- |
* | "Document uploaded on your case" |
*
* @param {Notifications_Document_Uploaded_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_document_uploaded_title = /** @type {((inputs?: Notifications_Document_Uploaded_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Document_Uploaded_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_document_uploaded_title(inputs)
	return pt_br2_notifications_document_uploaded_title(inputs)
});